import postAPI from './postAPI.js'

export default async function postReopenStep(body) {
    const data = await postAPI('admin/taskinstances/steps/reopen', body);
    return data;
}
